import { createResponsesImage } from '../createResponsesImage/createResponsesImage';
import component from './ResponsesImageEmptyBoxSvg';

export const ResponsesImageEmptyBox = createResponsesImage({
  name: 'ResponsesImageEmptyBox',
  component,
});
